export default "<p>\n  logout works!\n</p>\n";